import {WorkSortOrderValue} from "../../../constants/constants";

/**
 * ハンド一覧検索条件
 */
export interface FormWorkSearchCond {
  keyword: string,
  listCount: number,
  sortOrder: WorkSortOrderValue,
}

/**
 * Work登録フォームステップ
 */
export const WORK_FORM_STEP = {
  WORK_SELECT: 0,
  WORK_INPUT: 1,
} as const;

export type WorkFormStep = typeof WORK_FORM_STEP[keyof typeof WORK_FORM_STEP];


/**
 * ワーク属性表用タイプ
 */
export interface AttrListRowType {
  key: string;
  label: string;
  meta?: Record<string, any>
}

/**
 * ワーク属性表
 */
export const workAttrList = {
  nameJp: {key: "nameJp", label: "対象物名（日本語表記）"},
  nameEn: {key: "nameEn", label: "対象物名（英語表記）"},
  code: {key: "code", label: "JANコード/部品コード"},
  contentWeight: {key: "contentWeight", label: "内容重量[g]", meta: {unit: 'g'}},
  contentVolume: {key: "contentVolume", label: "内容容量[ℓ]", meta: {unit: 'ℓ'}},
  softMaterial: {key: "softMaterial", label: "柔軟物か", meta: {yes: "柔軟物", no: "柔軟物ではない"}},
  deformable: {key: "deformable", label: "不定形物か", meta: {yes: "不定形物", no: "不定形物ではない"}},
  manufacturer: {key: "manufacturer", label: "会社名"},
  description: {key: "description", label: "説明"},
  modelType: {key: "modelType", label: "モデル種別"},
  modelFile: {key: "modelFile", label: "モデルファイル"},
  fileType: {key: "fileType", label: "入力ファイル方式"},
  when: {key: "when", label: "測定日時"},
  who: {key: "who", label: "測定者"},
  scale: {key: "scale", label: "スケール", meta: {yes: "1/1000にスケール"}},

  classId: {key: "class-id", label: "クラスID"},
  instanceId: {key: "instance-id", label: "インスタンスID"},
  modelId: {key: "model-id", label: "モデルID"},

  created: {key: "created", label: "登録日時"}, // inserted と同じ値が入っているがとりあえず created で表示
  creator: {key: "creator", label: "登録者"},

  children: {key: "children", label: "子クラスのID"},

  classAttr: {key: "class_attr", label: "クラス属性"},
  instanceAttr: {key: "instance_attr", label: "インスタンス属性"},
} as const satisfies Readonly<Record<string, AttrListRowType>>
